<template>
  <div class="inner">
    <Nav />
    <Contract v-if="hasId" />
    <div class="box" v-else>
      <form>
        <div class="columns">
          <div class="column col-3">
            <label class="text-bold form-label">Naročnik</label>
            <Select :data="clientList" v-model="filter.idClient" />
          </div>
          <div class="col-3 column">
            <label class="text-bold form-label">Številka javnega naročila</label>
            <InputText v-model="filter.jnTitle" />
          </div>
          <div class="col-3 column">
            <label class="text-bold form-label">Pogodba</label>
            <InputText v-model="filter.contract" />
          </div>
          <div class="col-3 column">
            <label class="text-bold form-label">Interna številka pogodbe</label>
            <InputText v-model="filter.internalId" />
          </div>
          <div class="col-3 column padding-top10">
            <label class="text-bold form-label">Znesek pogodbe</label>
            <InputNumeric :decimals="2" v-model="filter.amount" />
          </div>
          <div class="col-3 column padding-top10">
            <label class="text-bold form-label">Izvajalec pogodbe</label>
            <InputText v-model="filter.contractor" />
          </div>
          <div class="col-3 column padding-top10">
            <label class="text-bold form-label">Status</label>
            <Select :data="statusList" v-model="filter.status" />
          </div>
          <div class="col-2 column padding-top47">
            <button class="button" @click.prevent="getData(null, true)">Išči</button>
          </div>
        </div>
      </form>
      <br />
      <div class="columns padding-bottom10">
        <div class="column text-bold">Seznam pogodb</div>
        <div class="column text-right"><a href @click.prevent="toXls">Izvoz v excel</a></div>
      </div>
      <Tables :columns="cols" :outerPageNumber="filter.pagerPage" :data="data" @page-filter-change="getData($event)" :searchEnabled="false" :rowStyleList="[{ viewed: (data) => recordExists('contractList' + data.id) }, { colRed: 'active === false' }]" />
    </div>
  </div>
</template>

<script lang="ts">
import Contract from '@/components/Contract.vue'
import Tables from '@/components/common/TablesDb.vue'
import Select from '@/components/common/Select.vue'

import { defineComponent, ref, computed, markRaw, watch } from 'vue'
import { useApi } from '@/lib/api'
import { useRoute } from 'vue-router'
import Nav from '@/components/Nav.vue'
import InputText from '@/components/common/InputText.vue'
import InputNumeric from '@/components/common/InputNumeric.vue'
import { downloadStream, useAppViewedList } from '@/lib/common'
import { useStore } from 'vuex'

const actions = markRaw({
  template: `<router-link :to="{params: {id: data.id }}" tag="a" class="text-bold">Preglej </router-link>`,
  props: {
    data: {}
  }
})

export default defineComponent({
  components: { Tables, Contract, Nav, Select, InputText, InputNumeric },
  setup() {
    const { recordExists } = useAppViewedList()
    const _store = useStore()
    const _api = useApi()
    const _route = useRoute()
    const cols = ref([
      { field: 'id', caption: '#', dbField: 'np.id', hidden: true },
      { field: 'jnTitle', caption: 'Št. JN', dbField: 'jn' },
      { field: 'internalId', caption: 'Int. št. pogodbe', dbField: 'interni_opis' },
      { field: 'title', caption: 'Pogodba', dbField: 'np.naziv' },
      { field: 'contractor', caption: 'Izvajalec', dbField: 'izvajalec' },
      //{ field: 'client.title', caption: 'Naročnik', dbField: 'narocnik' },
      { field: 'value', caption: 'Znesek pogodbe', dbField: 'vrednost', class: 'text-right-important', format: { type: 'number', format: 2 } },
      { field: 'dateFrom', caption: 'Poročanje od', format: { type: 'date', format: 'DD.MM.YYYY' }, dbField: 'datum_od' },
      { field: 'dateTo', caption: 'Poročanje do', format: { type: 'date', format: 'DD.MM.YYYY' }, dbField: 'datum_do' },
      //{ field: 'active', caption: 'Aktivnost', format: { type: 'yesno' }, dbField: 'NP.aktiven' },
      { caption: 'Akcija', component: actions, class: 'nowrap actions' }
    ])
    const data = ref([])
    const statusList = [
      { id: null, text: '- izberi -' },
      { id: 1, text: 'Aktivne pogodbe' },
      { id: 2, text: 'Neaktivne/poročane pogodbe' }
    ]
    const filter = ref({ pagerPage: 1, pagerPageSize: 20, pagerSort: 'np.id desc', status: 1 })
    const hasId = computed(() => _route.params.id)
    const clientList = ref([])

    const getData = async (e?: any, f?: any) => {
      if (!hasId.value) {
        if (e) {
          filter.value.pagerPage = e.page
          filter.value.pagerSort = e.sort ? e.sort : 'np.id desc'
        } else if (filter.value.pagerPage > 1) {
          if (f) {
            filter.value.pagerPage = 1
          }
          return
        }
        const res = await _api.post<any>('contractList', filter.value, true)
        data.value = res.data
      }
    }

    const toXls = async () => {
      _store.commit('appLoading', true)
      try {
        const res = await _api.axios.post<any>('contractList?export=true', filter.value, { responseType: 'blob' })
        if (res.status === 200) {
          downloadStream(res.data, 'Pogodbe.xlsx')
        }
      } finally {
        _store.commit('appLoading', false)
      }
    }

    const getSifData = async () => {
      const res = await _api.get<any>('clientList')
      clientList.value = res.data.map((x: any) => ({
        id: x.id,
        text: x.title
      }))
      const n = { id: null, text: '- izberi -' }
      clientList.value.unshift(n as never)
    }

    watch(hasId, () => getData())

    getData()
    getSifData()

    return { cols, data, filter, getData, hasId, clientList, toXls, recordExists, statusList }
  }
})
</script>
